import { useSelector } from 'react-redux';
import { selectUserBalanceLoadState } from 'services/user/user.selectors';
import { selectPendingSessionsLoadState } from './pendingSessions.selectors';

export const usePendingSessionsModal = () => {
  const pendinSessionsLoadState = useSelector(selectPendingSessionsLoadState);
  const balanceRequestState = useSelector(selectUserBalanceLoadState);

  const isPendingSessionsLoading =
    (!pendinSessionsLoadState.isLoaded ||
      pendinSessionsLoadState.isInvalidated) &&
    !pendinSessionsLoadState.hasFailed;
  const isBalanceLoading =
    (!balanceRequestState.isLoaded || balanceRequestState.isInvalidated) &&
    !balanceRequestState.hasFailed;

  return {
    isLoading: isPendingSessionsLoading || isBalanceLoading,
    hasFailed: pendinSessionsLoadState.hasFailed,
  };
};
